import { useTranslation } from "react-i18next";

const PdfViewer = ({ src, title }) => {
  const { t } = useTranslation();

  return (
    <div className="px-4 md:px-8 py-6 md:py-10">
      <h1 className="text-xl md:text-2xl font-semibold text-darkBg dark:text-lightBg mb-6 uppercase tracking-wide">
        {title}
      </h1>

      <div className="w-full rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700 bg-white shadow-sm">
        <iframe
          src={`${src}#toolbar=1`}
          title={title}
          className="w-full"
          style={{ height: "min(85vh, 900px)", border: 0 }}
        />
      </div>

      <div className="flex flex-wrap gap-4 mt-4">
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#E1C17B] hover:underline text-sm md:text-base"
        >
          {t("openPdf")}
        </a>
        <a
          href={src}
          download
          className="text-[#E1C17B] hover:underline text-sm md:text-base"
        >
          {t("downloadPdf")}
        </a>
      </div>
    </div>
  );
};

export default PdfViewer;
